export default __webpack_public_path__ + "static/media/home-diagram.22acbd31.png";